import React from 'react';
import { Grid, Typography } from '@mui/material';
import { FlightLand, FlightTakeoffOutlined } from '@mui/icons-material';
import { formatDate, getDateFromSap } from '@core/utils';

interface IDetalhesFeriasCardProps {
    dataInicio: string;
    diasProgramados: number;
    diasAbono: number;
    adiantamento13: string;
    descricaoStatus: string;
}

const gridStyles = {
    marginTop: '0.5rem',
    cursor: 'pointer',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: '#fff',
    display: 'flex',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    width: '100%',
    borderRadius: '8px',
    padding: '1rem'
};

const textStyleTitle = {
    fontSize: '0.8rem',
    lineHeight: 1,
    fontWeight: 'bold',
    marginTop: '1rem'
};

const textStyleDescription = {
    fontSize: '0.8rem',
    lineHeight: 1,
    marginTop: '0.5rem',
    color: 'rgba(0, 0, 0, 0.87)'
};

const flagStyle = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    margin: 0,
    color: '#fff',
    fontWeight: '600',
    background: '#FF00FF',
    padding: '2px 5px',
    borderRadius: '5px',
    gap: '5px'
};

export const DetalhesFeriasCard: React.FC<IDetalhesFeriasCardProps> = ({ dataInicio, diasProgramados, diasAbono, adiantamento13, descricaoStatus }) => {
    return (
        <Grid item xs={12} sx={{ ...gridStyles }}>
            <Grid container justifyContent="space-between">
                <Grid item xs={12}>
                    <Typography component="span" sx={{ ...textStyleDescription, ...flagStyle }}>
                        {descricaoStatus === 'Quitado' ? <FlightLand /> : <FlightTakeoffOutlined />}
                        {descricaoStatus}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ ...textStyleTitle }}>Dias de férias</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{diasProgramados}</Typography>

                    <Typography sx={{ ...textStyleTitle }}>Adto. 13º salário</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{adiantamento13}</Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ ...textStyleTitle }}>Data de início</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{formatDate(getDateFromSap(dataInicio), false)}</Typography>

                    <Typography sx={{ ...textStyleTitle }}>Dias de abono</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{diasAbono}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};
